import { captureAPIs } from "./captureAPIs";
import { coreClipAPIs } from "./clipDetailsAPIs";
import { contentImagesAPIs } from "./contentImagesAPIs";
import { contentIngestionAPIs } from "./contentIngestionAPIs";
import { coreContentTagsAPIs } from "./contentTags";
import { contentVariantAPIs } from "./contentVariantAPIs";
import { downloadStreamAPIs } from "./downloadStreamAPIs";
import { coreFieldAPIs } from "./fieldsAPIs";
import { filmstripAPIs } from "./filmstripAPIs";
import { mediaAPIs } from "./mediaAPIs";
import { newsAPIs } from "./newsAPIs";
import { notificationAPIs } from "./notificationAPIs";
import { segmentAPIs } from "./segmentAPIs";
import { streamsAPIs } from "./streamsAPIs";
import { subtitleAPIs } from "./subtitleAPIs";
import { coreTagsAPIs } from "./tagsAPIs";
import { thumbnailTemplateAPIs } from "./thumbnailTemplateAPIs";
import { transformVideosAPIs } from "./transformVideosAPIs";
import { typesenseAPIs } from "./typesenseAPIs";
import { typesensePublishesAPIs } from "./typesensePublishesAPIs";

const coreAPIs = {
  ...contentIngestionAPIs,
  ...contentVariantAPIs,
  ...contentImagesAPIs,
  ...downloadStreamAPIs,
  ...coreClipAPIs,
  ...newsAPIs,
  ...thumbnailTemplateAPIs,
  ...mediaAPIs,
  ...typesenseAPIs,
  ...captureAPIs,
  ...transformVideosAPIs,
  ...segmentAPIs,
  ...subtitleAPIs,
  ...notificationAPIs,
  ...coreFieldAPIs,
  ...coreTagsAPIs,
  ...coreContentTagsAPIs,
  ...filmstripAPIs,
  ...streamsAPIs,
  ...typesensePublishesAPIs,
};

export default coreAPIs;
